import React from 'react';
import withGetResourceDetails from '../../withGetResourceDetails';

import './AudioMessage.css';

@withGetResourceDetails
class AudioMessage extends React.Component {
  state = {
    source: null,
    height: 0,
    width: 0,
    overlayHidden: false
  };
  
  onClick = () => {
    if (this.props.resource && this.props.getResourceDetails) {
      this.props.getResourceDetails(this.props.resource, (error, result) => {
        if (!error) {
          this.setState({
            source: result.temporaryUrl,
            overlayHidden: true
          });
        } else {
          console.error(error);
        }
      });
    }
  }
  
  componentDidMount() {
    this.setState({
      height: this.divElement.clientHeight,
      width: this.divElement.clientWidth
    });
  }
  
  render() {
    return (
      <div className={'audioMessageContainer'}>
        <div
          onClick={this.onClick}
          className={'audioMessageOverlay ' + (this.state.overlayHidden ? 'customHide' : '')}
          style={{"height": this.state.height, "width": this.state.width}}/>
        <audio
          className={'audioElement ' + (this.state.overlayHidden ? '' : 'blur')}
          ref={ (divElement) => { this.divElement = divElement } }
          controls
          controlsList="nodownload"
          src={this.state.source}>
          <p>Playing audio messages in the Internet Explorer browser is currently not supported. Please consider using a different browser.</p>
        </audio>
      </div>
    )
  }
}

export default AudioMessage;
